import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

export const dioceseSchema = new schema.Entity(
  'dioceses',
  {},
  {
    idAttribute: 'id',
  }
)

// Route::get('dioceses/diocese/{id}/get', 'DioceseController@getById');
export const diocese_getById_Api = {
  backend: `Route::get('dioceses/diocese/{id}/get', 'DioceseController@getById');`,
  root: API_ROOT_URL,
  path: '/dioceses/diocese/:id/get',
  method: 'GET',
  schema: dioceseSchema,
  transform: createTransform(dioceseSchema, 'data'),
}
// Route::get('dioceses/diocese/get-dioceses', 'DioceseController@getDioceses');
export const diocese_getDioceses_Api = {
  backend: `Route::get('dioceses/diocese/get-dioceses', 'DioceseController@getDioceses');`,
  root: API_ROOT_URL,
  path: '/dioceses/diocese/get-dioceses',
  method: 'GET',
  paramsFields: ['sort_by', 'keyword', 'country_id', 'archdiocese_id', 'diocese_typecd'],
  schema: dioceseSchema,
  transform: createListTransform(dioceseSchema),
}


// Route::post('dioceses/diocese/create-new', 'DioceseController@createDiocese');
export const diocese_createDiocese_Api = {
  backend: `Route::post('dioceses/diocese/create-new', 'DioceseController@createDiocese');`,
  root: API_ROOT_URL,
  path: '/dioceses/diocese/create-new',
  method: 'POST',
  paramsFields: [],
  schema: dioceseSchema,
  transform: createTransform(dioceseSchema, 'data'),
}
// Route::post('dioceses/diocese/{id}/update', 'DioceseController@updateDiocese');
export const diocese_updateDiocese_Api = {
  backend: `Route::post('dioceses/diocese/{id}/update', 'DioceseController@updateDiocese');`,
  root: API_ROOT_URL,
  path: '/dioceses/diocese/:id/update',
  method: 'POST',
  paramsFields: [],
  schema: dioceseSchema,
  transform: createTransform(dioceseSchema, 'data'),
}
// Route::post('dioceses/diocese/{id}/delete', 'DioceseController@deleteDiocese');
export const diocese_deleteDiocese_Api = {
  backend: `Route::post('dioceses/diocese/{id}/delete', 'DioceseController@deleteDiocese');`,
  root: API_ROOT_URL,
  path: '/dioceses/diocese/:id/delete',
  method: 'POST',
  paramsFields: [],
  schema: dioceseSchema,
  transform: createTransform(dioceseSchema, 'data'),
}

export const getArchdiocesesHighlighted_Api = {
  backend: `Route::get('dioceses/get-archdioceses-highlighted', 'DioceseController@getArchdiocesesHighlighted');`,
  root: API_ROOT_URL,
  path: '/dioceses/get-archdioceses-highlighted',
  method: 'GET',
  paramsFields: ['country_id', 'diocese_typecd'],
  schema: dioceseSchema,
  transform: createListTransform(dioceseSchema),
}

export const diocese_getDirectoryStats_Api = {
  backend: `Route::get('dioceses/get-directory-stats', 'DioceseController@getDirectoryStats');`,
  root: API_ROOT_URL,
  path: '/dioceses/get-directory-stats',
  method: 'GET',
}